<app-alert></app-alert>
<router-outlet></router-outlet>
<app-event-products-calculator >
</app-event-products-calculator>
